import { withInstall } from '../../utils/install';
import BottomNav from './index.vue';

export const IvueBottomNav = withInstall(BottomNav);
export default IvueBottomNav;

export * from './index.vue';
